export default __webpack_public_path__ + "static/media/coppe-white.4a5a1203.png";